import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import GroupBottom from '../../groupdtail/GroupBottom';
import StepButtom from '../../../fixbar/StepButtom';
import { Link } from 'react-router-dom';

const textClick = () => {
  alert('모임이 만들고 플젝홈으로');
};

export default function FitgroupChangeStep2({
  groupInfo,
  fitIntroductContent,
  infotext,
  placeholder,
  updateNext,
  setFitIntroductContent,
  dataSubmit,
  fitinfo,
  setFitinfo,
  publics,
  setPublics,
}) {
  const [next, setNext] = useState(false);

  const fitinfoChange = (e) => {
    setFitinfo(e.target.value);
  };
  const publicsChange = (e) => {
    setPublics(e.target.checked);
  };

  // const publicsChange = (e) => {
  //     publics[e.target.value] = e.target.checked ? true : false;
  // // if(periodCheckVaildate(weekCheck) && fitinfoVaildate())
  // //     setNext(true);
  // // setWeekCheck(weekCheck);
  // }
  const fitinfoVaildate = () => {
    return fitinfo.length > 2;
  };
  useEffect(() => {
    if (fitinfoVaildate()) setNext(true);
    else setNext(false);
  }, [fitinfo]);
  return (
    <Fitinfoarea>
      <Fitinfotit>모임 소개</Fitinfotit>
      <Fitinfosubtit>{infotext}</Fitinfosubtit>
      <Textarea
        value={fitIntroductContent}
        onChange={fitinfoChange}
        placeholder={placeholder}
      >
        {fitinfo}
      </Textarea>


      {next ? (
        <StepButtom
          text={'모임 만들기'}
          color={'#4e4e4e'}
          position={'fixed'}
          prevdisplay={'flex'}
          updateNext={updateNext}
          textClick={dataSubmit}
        />
      ) : (
        <StepButtom
          text={'모임 만들기'}
          color={'#4e4e4e'}
          position={'fixed'}
          prevdisplay={'flex'}
          updateNext={updateNext}
          textClick={dataSubmit}
          bg={'#d8d8d8'}
        />
      )}
    </Fitinfoarea>
  );
}
/*

      <ToggleArea>
        <Toggleinner>
          <Toggletit>비공개 모집</Toggletit>
          <Switchinput
            type="checkbox"
            id="weekedSW"
            onChange={publicsChange}
            value={publics}
            defaultChecked={publics}
          ></Switchinput>
          <Switchlabel for="weekedSW"></Switchlabel>
        </Toggleinner>
        <ToggleText>
          *비공개로 설정할 경우 메인페이지에는 보이지 않습니다.
        </ToggleText>
      </ToggleArea>
*/
const Fitinfoarea = styled.div`
  padding: calc(100vw * (79.5 / 375)) calc(100vw * (17 / 375))
    calc(100vw * (50 / 375)) calc(100vw * (16 / 375));
`;

const Fitinfotit = styled.h1`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  letter-spacing: 0.32px;
  padding-bottom: calc(100vw * (2 / 375));
`;
const Fitinfosubtit = styled.p`
  font-size: calc(100vw * (11 / 375));
  line-height: 1.55;
  color: #7f7f7f;
  padding-bottom: calc(100vw * (15 / 375));
`;
const Textarea = styled.textarea`
  width: 100%;
  height: calc(100vw * (153 / 375));
  border-radius: calc(100vw * (5 / 375));
  border: solid calc(100vw * (1 / 375)) #d5d5d5;
  background-color: #ffffff;
  font-size: calc(100vw * (14 / 375));
  line-height: 1.57;
  padding: calc(100vw * (10 / 375)) calc(100vw * (12 / 375));

  &::placeholder {
    color: #c6c6c6;
  }
  &:focus {
    border: solid calc(100vw * (1 / 375)) #ffcf19;
  }
`;

const Switchinput = styled.input`
  display: none;

  &:checked + label {
    background-color: #ffcf19;
  }
  &:checked + label::before {
    transform: translate(calc(100vw * (16 / 375)), -50%);
  }
`;
const Switchlabel = styled.label`
  position: relative;
  padding: 0 calc(100vw * (9 / 375));
  display: flex;
  justify-content: space-between;
  width: calc(100vw * (34 / 375));
  height: calc(100vw * (14 / 375));
  border-radius: calc(100vw * (20 / 375));
  background-color: rgb(116, 116, 116, 0.4);
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  letter-spacing: -0.29px;
  color: #4e4e4e;

  &::before {
    content: '';
    display: block;
    width: calc(100vw * (20 / 375));
    height: calc(100vw * (20 / 375));
    box-shadow: 0 calc(100vw * (1 / 375)) calc(100vw * (3 / 375)) 0
      rgba(0, 0, 0, 0.21);
    background-color: #ffffff;
    position: absolute;
    left: calc(100vw * (-1 / 375));
    top: 50%;
    transform: translateY(-50%);
    transition: all 0.4s ease;
    border-radius: calc(100vw * (13 / 375));
    color: #4e4e4e;
    line-height: calc(100vw * (26 / 375));
    text-align: center;
  }
`;
const ToggleText = styled.span`
  display: block;
  font-size: calc(100vw * (10 / 375));
  padding-top: calc(100vw * (5 / 375));
  letter-spacing: calc(100vw * (0.2 / 375));
  color: #989898;
`;
const ToggleArea = styled.div`
  padding-top: calc(100vw * (37 / 375));
`;
const Toggleinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const Toggletit = styled.p`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  letter-spacing: calc(100vw * (0.32 / 375));
`;
